import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {getToken} from './token_fetcher'
import {doREQUEST_ERROR, doREQUEST_COMPLETE, doPROJECT_SCHEDULE_CONFIG_DELETE} from '../state'

export const REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE = 'REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE'
export const doREQUEST_PROJECT_SCHEDULE_CONFIG_DELETE = createDoRequestAction(REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE)

export const requestProjectScheduleConfigDeleteActionCreators = {
  doREQUEST_PROJECT_SCHEDULE_CONFIG_DELETE,
}

export function* requestProjectScheduleConfigDelete({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectScheduleConfigDelete')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {requestId, projectId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'POST',
    url: `${API_URL}/v1/web/project-schedule-config-delete`,
    accessToken,
    data: {projectId},
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE,
          fromPayload: payload,
          requestId,
          url: '/v1/web/project-schedule-config-delete',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SCHEDULE_CONFIG_DELETE({projectId}))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectScheduleConfigDeleteSaga() {
  yield takeEvery(REQUEST_PROJECT_SCHEDULE_CONFIG_DELETE, requestProjectScheduleConfigDelete)
}
